// externals
import React from 'react';

// libraries
import { useSelector, useDispatch } from 'react-redux';

// selectors, actions & types
import {
    isDealRefreshModalVisible,
    offerUpdatesRefreshClicked,
    refreshDealRequested,
    setWorkflowEvaluation,
    type DealRefreshStateTree
} from '@makemydeal/dr-sales-checkin-store';

// components
import { DealRefreshModalView } from './DealRefreshModalView';

export const DealRefreshModal = (): React.JSX.Element | null => {
    const dispatch = useDispatch();
    const isVisible = useSelector((state: DealRefreshStateTree) => isDealRefreshModalVisible(state));

    const handleRefresh = () => {
        dispatch(setWorkflowEvaluation(true));
        dispatch(offerUpdatesRefreshClicked());
        dispatch(refreshDealRequested());
    };

    if (!isVisible) return null;

    return <DealRefreshModalView onRefresh={handleRefresh} />;
};

export default DealRefreshModal;
